import { Outlet, useLocation } from "react-router-dom"
import { useEffect } from "react"
import Navbar from "./Navbar"
import Footer from "./Footer"
import AdminEditToolbar from "./AdminEditToolbar"
import { EditModeProvider } from "@/contexts/EditModeContext"

export default function Layout() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <EditModeProvider>
      <div className="min-h-screen flex flex-col bg-slate-950 text-white">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <AdminEditToolbar />
      </div>
    </EditModeProvider>
  )
}
